export default __webpack_public_path__ + "static/media/Code review-amico.b1b578af.svg";